import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-user-info-dialog',
  templateUrl: './user-info-dialog.component.html',
  styleUrls: ['./user-info-dialog.component.css'],
  standalone: false,
})
export class UserInfoDialogComponent implements OnInit {
  tool: string = 'No tool';
  names: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    if (data) {
      this.tool = data.tool || this.tool;
      this.capitalizeFirstLetter(this.tool);
      if (data.names) {
        this.names = data.names || this.names;
      }
    }
  }

  ngOnInit(): void {}

  capitalizeFirstLetter(str: string) {
    this.tool = str.charAt(0).toUpperCase() + str.slice(1);
  }
}
